export { default } from './CoreLayout'
